import _, { isEmpty } from 'underscore';
import { PodcastTemplateConfig } from 'redux/middleware/api/podcast-service';
import { Dimensions } from 'types';
import measurement, { ViewportHeight, ViewportWidth } from 'utils/measurement';
import { ProgressState } from '../types';

/*
 * progress config will have height and width as well as top/bottom and left/right
 */
function getProgressDimensions(
  progress: PodcastTemplateConfig['progress'],
): Dimensions<ViewportHeight, ViewportWidth> {
  const vhKeys = ['top', 'bottom', 'height'];

  const provided = _.mapObject(
    {
      ...progress.position?.properties,
      ..._.pick(progress.style, 'height', 'width'),
    },
    (val, key) => measurement(val, vhKeys.includes(key) ? 'vh' : 'vw'),
  );

  const dimensions: any = {};

  if (provided.top) {
    dimensions.top = provided.top;
  } else if (provided.bottom && provided.height) {
    dimensions.top = provided.bottom.minus(provided.height);
  } else {
    return undefined;
  }

  if (provided.left) {
    dimensions.left = provided.left;
  } else if (provided.right && provided.width) {
    dimensions.left = provided.right.minus(provided.width);
  } else {
    return undefined;
  }

  if (provided.height) {
    dimensions.height = provided.height;
  } else if (provided.bottom && provided.top) {
    dimensions.height = provided.bottom.minus(provided.top);
  } else {
    return undefined;
  }

  if (provided.width) {
    dimensions.width = provided.width;
  } else if (provided.left && provided.right) {
    dimensions.width = provided.right.minus(provided.left);
  } else {
    return undefined;
  }

  return dimensions;
}

export function getProgress(config: PodcastTemplateConfig): ProgressState {
  const progress = config?.progress;

  if (!progress || isEmpty(progress) || !progress?.enabled) return undefined;

  const dimensions = getProgressDimensions(progress);

  return {
    enabled: progress.enabled,
    color: progress.unelapsedColor,
    fillColor: progress.elapsedColor,
    type: progress.type,
    ...dimensions,
  };
}
